import { AppHeader } from '../components/AppHeader.js';
import { PrefsModeToggle } from '../components/settings/PrefsModeToggle.js';
import { DisplayPrefs } from '../components/settings/DisplayPrefs.js';
import { PersonalVocabList } from '../components/settings/PersonalVocabList.js';
import { DataIO } from '../components/settings/DataIO.js';
import { usePrefs } from '../lib/usePrefs.js';

export function Settings(): JSX.Element {
  const prefsState = usePrefs();

  return (
    <>
      <AppHeader leftMode="back" />
      <main className="flex-1 overflow-y-auto px-4 pb-2">
        <PrefsModeToggle {...prefsState} />
        <Divider />
        <DisplayPrefs {...prefsState} />
        <Divider />
        <PersonalVocabList />
        <Divider />
        <DataIO />
      </main>
    </>
  );
}

function Divider(): JSX.Element {
  return <div className="h-px bg-border my-4" />;
}
